import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const QMS_URL = '/ris-renovate/v1/qms';
const QMS_QUEUE_URL = '/ris-renovate/v1/qms-patients';

export enum QMS_Type {
  OVERVIEW,
  DEVICE,
}

export enum QMS_STATUS {
  Inactive,
  Active,
}

export interface QMS {
  id: string;
  created_at: string;
  created_by_id: string;
  updated_at: string;
  updated_by_id: string;
  status: number;
  institution_id: string;
  institution?: any;
  name: string;
  type: number;
  device_id: string;
  morning_shift_start: string;
  morning_shift_end: string;
  afternoon_shift_start: string;
  afternoon_shift_end: string;
  doctor_id: string;
  doctor?: any;
  statistic?: {
    in_process: number;
    wait_list: number;
    miss_call: number;
  };
  wait_list_window_patient_name: number;
  wait_list_window_patient_age: number;
  wait_list_window_receive_at: number;
  wait_list_window_wait_time: number;
  wait_list_popup_patient_name: number;
  wait_list_popup_patient_age: number;
  wait_list_popup_receive_at: number;
  wait_list_popup_wait_time: number;
  in_process_window_patient_name: number;
  in_process_window_patient_age: number;
  in_process_window_receive_at: number;
  in_process_window_wait_time: number;
  in_process_popup_patient_name: number;
  in_process_popup_patient_age: number;
  in_process_popup_receive_at: number;
  in_process_popup_wait_time: number;
  miss_call_window_patient_name: number;
  miss_call_window_patient_age: number;
  miss_call_window_receive_at: number;
  miss_call_window_wait_time: number;
  miss_call_popup_patient_name: number;
  miss_call_popup_patient_age: number;
  miss_call_popup_receive_at: number;
  miss_call_popup_wait_time: number;
  qms_linked_ids?: string[];
  qms_linked?: QMS[];
  in_process_count: number;
  wait_list_count: number;
  miss_call_count: number;
}

export interface ParamsGetQMS {
  status?: QMS_STATUS;
  institution_ids?: string[];
  limit?: number;
  name?: string;
  doctor_id?: string;
  offset?: number;
  name_contain?: string;
  sort_field?: '' | 'active' | 'name' | 'institution_id' | 'updated_at';
  sort_order?: SORT_ORDER;
  type?: QMS_Type;
  updated_at_from?: string;
  updated_at_to?: string;
  enable_statistics?: boolean;
}
export interface ResponseGetQMS extends DefaultResponse {
  data: QMS[];
}
export const getQMS = async (params: ParamsGetQMS = {}) => {
  const response = (await api({
    url: QMS_URL + '/search',
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetQMS>;

  return response.data;
};

export interface ResponseGetQMSDetail extends DefaultResponse {
  data: QMS;
}

export const getQMSDetail = async (id: string) => {
  const response = (await api({
    url: `${QMS_URL}/${id}`,
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetQMSDetail>;

  const data = response.data.data;

  if (data.qms_linked_ids) {
    const linkedData = await Promise.all(data.qms_linked_ids.map((id) => getQMSDetail(id)));
    data.qms_linked = linkedData;
  }

  return data;
};

export interface ParamsCreateQMS {
  afternoon_shift_end: string;
  afternoon_shift_start: string;
  device_id: string;
  doctor_id: string;
  in_process_popup_patient_age: number;
  in_process_popup_patient_name: number;
  in_process_popup_receive_at: number;
  in_process_popup_wait_time: number;
  in_process_window_patient_age: number;
  in_process_window_patient_name: number;
  in_process_window_receive_at: number;
  in_process_window_wait_time: number;
  institution_id: string;
  miss_call_popup_patient_age: number;
  miss_call_popup_patient_name: number;
  miss_call_popup_receive_at: number;
  miss_call_popup_wait_time: number;
  miss_call_window_patient_age: number;
  miss_call_window_patient_name: number;
  miss_call_window_receive_at: number;
  miss_call_window_wait_time: number;
  morning_shift_end: string;
  morning_shift_start: string;
  name: string;
  qms_linked_ids: string[];
  status: number;
  type: number;
  wait_list_popup_patient_age: number;
  wait_list_popup_patient_name: number;
  wait_list_popup_receive_at: number;
  wait_list_popup_wait_time: number;
  wait_list_window_patient_age: number;
  wait_list_window_patient_name: number;
  wait_list_window_receive_at: number;
  wait_list_window_wait_time: number;
}
export const createQMS = async (data: ParamsCreateQMS) => {
  const response = (await api({
    url: QMS_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateQMS {
  afternoon_shift_end: string;
  afternoon_shift_start: string;
  device_id: string;
  doctor_id: string;
  in_process_popup_patient_age: number;
  in_process_popup_patient_name: number;
  in_process_popup_receive_at: number;
  in_process_popup_wait_time: number;
  in_process_window_patient_age: number;
  in_process_window_patient_name: number;
  in_process_window_receive_at: number;
  in_process_window_wait_time: number;
  institution_id: string;
  miss_call_popup_patient_age: number;
  miss_call_popup_patient_name: number;
  miss_call_popup_receive_at: number;
  miss_call_popup_wait_time: number;
  miss_call_window_patient_age: number;
  miss_call_window_patient_name: number;
  miss_call_window_receive_at: number;
  miss_call_window_wait_time: number;
  morning_shift_end: string;
  morning_shift_start: string;
  name: string;
  qms_linked_ids: string[];
  status: number;
  type: number;
  wait_list_popup_patient_age: number;
  wait_list_popup_patient_name: number;
  wait_list_popup_receive_at: number;
  wait_list_popup_wait_time: number;
  wait_list_window_patient_age: number;
  wait_list_window_patient_name: number;
  wait_list_window_receive_at: number;
  wait_list_window_wait_time: number;
}
export const updateQMS = async (id: string, data: ParamsUpdateQMS) => {
  const response = (await api({
    url: `${QMS_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteQMS = async (id: string) => {
  const response = (await api({
    url: `${QMS_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};

export interface ParamsUpdateQueueItem {
  qms_status: number;
}

export const pushQMS = async ({ qms_id, institution_id, order_ids }: { qms_id: string, institution_id: string, order_ids: string[] }) => {
  const response = (await api({
    url: `${QMS_QUEUE_URL}`,
    method: 'POST',
    data: {
      qms_id,
      institution_id,
      order_ids,
    },
  })) as AxiosResponse<any>;

  return response;
};

export const updateQueueItem = async (id: string, data: ParamsUpdateQueueItem) => {
  const response = (await api({
    url: `${QMS_QUEUE_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateQMSItemPosition {
  tail: string;
  head: string;
}

export const updateQMSItemPosition = async (id: string, data: ParamsUpdateQMSItemPosition) => {
  const response = (await api({
    url: `${QMS_QUEUE_URL}/${id}/position`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};


export const getQMSProfile = async () => {
  const response = (await api({
    url: `${QMS_URL}/profiles`,
    method: 'GET',
  })) as AxiosResponse<any>;

  return response.data;
}

export interface ParamsUpdateQMSProfile {
  qms: {
    id: string;
    doctor_id: string;
    status: number;
    morning_shift_start: string;
    morning_shift_end: string;
    afternoon_shift_start: string;
    afternoon_shift_end: string;
  }[];
  institution_id: string;
  qms_order_default_id: string;
  qms_order_worklist_id: string;
}

export const updateQMSProfile = async (data: ParamsUpdateQMSProfile) => {
  const response = (await api({
    url: `${QMS_URL}/profiles`,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};
